export default __webpack_public_path__ + "static/media/culture-icon-color.99a646e6.svg";